import React from 'react';

const BenefitsSection: React.FC = () => {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-purple-600 to-indigo-700 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl font-bold mb-12">
          즉시 받는 <span className="text-yellow-400">보너스</span>
        </h2>
        
        <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20">
          <div className="text-6xl mb-6">🎁</div>
          
          <h3 className="text-3xl font-bold mb-4 text-yellow-400">
            "실전 AI 툴 가이드"
          </h3>
          
          <p className="text-xl mb-6 text-purple-100">
            AI 에이전트를 위한 가이드
          </p>
          
          <div className="bg-yellow-400/20 border border-yellow-400/30 rounded-lg p-6">
            <p className="text-lg font-semibold">
              📧 가입 즉시 이메일로 전송
            </p>
          </div>
          
          <div className="mt-8 space-y-3 text-purple-100">
            <p className="flex items-center justify-center">
              <span className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-sm mr-3">✓</span>
              최신 AI 도구 활용법
            </p>
            <p className="flex items-center justify-center">
              <span className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-sm mr-3">✓</span>
              생산성 향상 비법
            </p>
            <p className="flex items-center justify-center">
              <span className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center text-white font-bold text-sm mr-3">✓</span>
              실무 적용 사례
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
